import { render, staticRenderFns } from "./LeaderHome.vue?vue&type=template&id=0edd0b64"
import script from "./LeaderHome.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeaderHome.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports